import { useMemo } from 'react'
import { getUserInvestedCampaigns, Campaign } from '@/services/api/campaign'
import { whiteLabelUtil } from '@/services/api/siteAssets'
import useApi from '@/services/hooks/useApiV2'
import useAuth from '@/services/hooks/useAuth'
import useSiteAssets from '../useSiteAssets/useSiteAssets'

const useUserInvestedCampaigns = () => {
  const { user } = useAuth()
  const { domain } = useSiteAssets()

  const { data, ...rest } = useApi<Campaign[]>({
    key: user ? `campaigns/${user.id}/` : false,
    request: () => getUserInvestedCampaigns(),
  })

  const userInvestedCampaigns = useMemo(
    () => data?.filter((c) => whiteLabelUtil.isAllowed(c, domain)),
    [data, domain]
  )

  return {
    userInvestedCampaigns,
    ...rest,
  }
}

export default useUserInvestedCampaigns
